import React, {useEffect} from 'react'
import TreeTypeTable from "../../components/TreeTypeTable";
import {Typography} from "@mui/material";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation} from "react-i18next";


const InfoPageTreeLayout = () =>{
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/tree-type",
            type:"pageView"
        }))
    });
    return(
        <div>
            <Typography style={{textAlign:"center", alignItems:"center"}}  variant="h3" gutterBottom>
                {t('info_page.tree.title' as any)}
            </Typography>
            <Typography paragraph>
                {t('info_page.tree.subtitle' as any)}
            </Typography>
            <TreeTypeTable/>
        </div>
    )
}
export default InfoPageTreeLayout
